import { Component, Input } from '@angular/core';
import { TranslatorService } from '../../services/utils/translator.service';

@Component({
  selector: 'ngx-leadin-help',
  templateUrl: './leadin-help.component.html',
  styleUrls: []
})
export class LeadinHelpComponent {
  @Input() defaultText;
}
